module.exports = __webpack_public_path__ + "img/sec_03.d1d49e56.png";